import { render, staticRenderFns } from "./GroupDetailPage.vue?vue&type=template&id=03debc5f&"
import script from "./GroupDetailPage.vue?vue&type=script&lang=js&"
export * from "./GroupDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports